import { useLighterCanvasEffects } from './canvas/room/canvasHelpers.ts';

export type TvQualityProfile = 'high' | 'medium' | 'low';

export interface TvQualityConfig {
  fruitShadowBlur: boolean;
  bombShadowBlur: boolean;
  bombUseGradient: boolean;
  calibPulse: boolean;
  juiceCount: number;
  explosionCount: number;
  maxParticles: number;
  renderOnlyWhenDirty: boolean;
  /** 16.6ms = 60fps, 33.3ms = 30fps — idle tick min interval when dirty=false. */
  idleFrameBudgetMs: number;
}

const PROFILES: Record<TvQualityProfile, TvQualityConfig> = {
  high: {
    fruitShadowBlur: false,
    bombShadowBlur: true,
    bombUseGradient: true,
    calibPulse: true,
    juiceCount: 14,
    explosionCount: 20,
    maxParticles: 350,
    renderOnlyWhenDirty: true,
    idleFrameBudgetMs: 16.6,
  },
  medium: {
    fruitShadowBlur: false,
    bombShadowBlur: false,
    bombUseGradient: true,
    calibPulse: true,
    juiceCount: 10,
    explosionCount: 14,
    maxParticles: 200,
    renderOnlyWhenDirty: true,
    idleFrameBudgetMs: 16.6,
  },
  low: {
    fruitShadowBlur: false,
    bombShadowBlur: false,
    bombUseGradient: false,
    calibPulse: false,
    juiceCount: 8,
    explosionCount: 12,
    maxParticles: 200,
    renderOnlyWhenDirty: true,
    idleFrameBudgetMs: 33.3,
  },
};

export function detectTvQualityProfile(canvas: HTMLCanvasElement): TvQualityProfile {
  if (useLighterCanvasEffects(canvas)) return 'low';
  if (typeof navigator !== 'undefined') {
    const ua = navigator.userAgent;
    if (/WebOS|Tizen|SMART-TV|NetCast|AFT[BMST]|HbbTV/i.test(ua)) return 'medium';
  }
  return 'high';
}

export function getTvQualityConfig(profile: TvQualityProfile): TvQualityConfig {
  return PROFILES[profile];
}
